import { render, staticRenderFns } from "./ApisTableItem.vue?vue&type=template&id=159dec84&scoped=true"
import script from "./ApisTableItem.vue?vue&type=script&lang=js"
export * from "./ApisTableItem.vue?vue&type=script&lang=js"
import style0 from "./ApisTableItem.vue?vue&type=style&index=0&id=159dec84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159dec84",
  null
  
)

export default component.exports